import projection_0_instance from "/app/common/view-models/player-matches.projection.js"
import { jsonDeserializeState as deserializeState_0_instance } from "@resolve-js/core"
import projection_1_instance from "/app/common/view-models/player-names.projection.js"
import { jsonDeserializeState as deserializeState_1_instance } from "@resolve-js/core"
import projection_2_instance from "/app/common/view-models/player-settings.projection.js"
import { jsonDeserializeState as deserializeState_2_instance } from "@resolve-js/core"
import projection_3_instance from "/app/common/view-models/league.projection.js"
import { jsonDeserializeState as deserializeState_3_instance } from "@resolve-js/core"
import projection_4_instance from "/app/common/view-models/season-ranks.projection.js"
import { jsonDeserializeState as deserializeState_4_instance } from "@resolve-js/core"
const constructorBindFunction =
    (
      constructorFunction,
      compileTimeOptions,
      compileTimeImports,
      runTimeOptions,
      runTimeImports
    ) => constructorFunction(
      { ...compileTimeOptions, ...runTimeOptions },
      { ...compileTimeImports, ...runTimeImports }
    )
const idempotentFunction = value => value
const name_0 = "PlayerMatches"
const projection_0 = projection_0_instance
const deserializeState_0 = deserializeState_0_instance
const name_1 = "PlayerName"
const projection_1 = projection_1_instance
const deserializeState_1 = deserializeState_1_instance
const name_2 = "PlayerSettings"
const projection_2 = projection_2_instance
const deserializeState_2 = deserializeState_2_instance
const name_3 = "LeagueData"
const projection_3 = projection_3_instance
const deserializeState_3 = deserializeState_3_instance
const name_4 = "SeasonRanks"
const projection_4 = projection_4_instance
const deserializeState_4 = deserializeState_4_instance
const viewModels = []

viewModels.push({
  name: name_0
, projection: projection_0
, deserializeState: deserializeState_0
})

viewModels.push({
  name: name_1
, projection: projection_1
, deserializeState: deserializeState_1
})

viewModels.push({
  name: name_2
, projection: projection_2
, deserializeState: deserializeState_2
})

viewModels.push({
  name: name_3
, projection: projection_3
, deserializeState: deserializeState_3
})

viewModels.push({
  name: name_4
, projection: projection_4
, deserializeState: deserializeState_4
})

export default viewModels